'use strict';

var React = require('react');

const useOnLoadImages = (carouselWrapperRef, setIsImgLoaded) => {
    React.useEffect(() => {
        const updateStatus = (images) => {
            setIsImgLoaded(images.every((image) => image.complete));
        };
        const imagesLoaded = (carouselWrapperRef === null || carouselWrapperRef === void 0 ? void 0 : carouselWrapperRef.current)
            ? Array.from(carouselWrapperRef.current.querySelectorAll('img'))
            : [];
        if (imagesLoaded.length === 0) {
            setIsImgLoaded(true);
        }
        const onLoad = () => updateStatus(imagesLoaded);
        imagesLoaded.forEach((image) => {
            if (image.complete) {
                onLoad();
            }
            else {
                image.addEventListener('load', onLoad, { once: true });
                image.addEventListener('error', onLoad, { once: true });
            }
        });
        return () => {
            imagesLoaded.forEach((image) => {
                image.removeEventListener('load', onLoad);
                image.removeEventListener('error', onLoad);
            });
        };
    }, [carouselWrapperRef]);
};

exports.useOnLoadImages = useOnLoadImages;
